/** 
 * Copyright © INOVUA TRADING.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.clampNamed = exports.clampSecond = exports.clampMinute = exports.clampHour = void 0;

var clamp = function clamp(value, _ref) {
  var min = _ref.min,
      max = _ref.max,
      _ref$circular = _ref.circular,
      circular = _ref$circular === void 0 ? true : _ref$circular;
  return value < min ? circular ? max : min : value > max ? circular ? min : max : value;
};

var clampHour = function clampHour(value, _ref2) {
  var max = _ref2.max,
      min = _ref2.min,
      circular = _ref2.circular;
  return clamp(value, {
    min: min || 0,
    max: max || 23,
    circular: circular
  });
};

exports.clampHour = clampHour;

var clampMinute = function clampMinute(value, _ref3) {
  var circular = _ref3.circular;
  return clamp(value, {
    min: 0,
    max: 59,
    circular: circular
  });
};

exports.clampMinute = clampMinute;

var clampSecond = function clampSecond(value, _ref4) {
  var circular = _ref4.circular;
  return clamp(value, {
    min: 0,
    max: 59,
    circular: circular
  });
};

exports.clampSecond = clampSecond;
var MAP = {
  second: clampSecond,
  seconds: clampSecond,
  minute: clampMinute,
  minutes: clampMinute,
  hour: clampHour,
  hours: clampHour
};

var clampNamed = function clampNamed(name, value, _ref5) {
  var circular = _ref5.circular,
      max = _ref5.max,
      min = _ref5.min;
  return MAP[name](value, {
    circular: circular,
    max: max,
    min: min
  });
};

exports.clampNamed = clampNamed;
var _default = clamp;
exports.default = _default;